const snowContainers = document.querySelectorAll('.hero--snow');

if (snowContainers.length) {
    const flake1 = document.createElement('div');
    const flake2 = document.createElement('div');
    const flake3 = document.createElement('div');
    const flake4 = document.createElement('div');

    for ( let i = 1; i <= 4; i++) {
        
    }

    flake1.classList.add('hero__flake1')
    flake2.classList.add('hero__flake2')
    flake3.classList.add('hero__flake3')
    flake4.classList.add('hero__flake4')

    for ( let i = 0; i < snowContainers.length; i++ ) {
        snowContainers[i].appendChild(flake1);
        // snowContainers[i].appendChild(flake2);
        snowContainers[i].appendChild(flake3);
        // snowContainers[i].appendChild(flake4);
    }
}